import { BsyUtils } from "./Utils";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
import every from "lodash/every";

import TextWidgetFilter from "./WidgetFilter/TextWidgetFilter";
import NumberWidgetFilter from "./WidgetFilter/NumberWidgetFilter";
import DatetimeWidgetFilter from "./WidgetFilter/DatetimeWidgetFilter";
import ComboCheckWidgetFilter from "./WidgetFilter/ComboCheckWidgetFilter";
import TextareaWidgetFilter from "./WidgetFilter/TextareaWidgetFilter";
import AddressWidgetFilter from "./WidgetFilter/AddressWidgetFilter";
import UserWidgetFilter from "./WidgetFilter/UserWidgetFilter";
import DeptWidgetFilter from "./WidgetFilter/DeptWidgetFilter";
import DeptGroupWidgetFilter from "./WidgetFilter/DeptGroupWidgetFilter";
import UserGroupWidgetFilter from "./WidgetFilter/UserGroupWidgetFilter";
import SignatureWidgetFilter from "./WidgetFilter/SignatureWidgetFilter";
import FileListWidgetFilter from "./WidgetFilter/FileListWidgetFilter";

export default class ShowRulesProcessor {
  constructor(props) {
    this.options = {
      ...props,
    };

    this.widgetFilterMap = this._initWidgetFilterMap();
    this.items = cloneDeep(props.fields || []);

    let fieldShowRules = [];
    if (Array.isArray(props.fieldShowRules)) {
      fieldShowRules = cloneDeep(props.fieldShowRules);
    }
    this.mergedShowRules = this.getMergedRules(fieldShowRules || []);
    this.order = this.getOrder(fieldShowRules || []);
    this.fields = this.initFields(this.items);
    this.sortedShowRules = this._getSortedRules(fieldShowRules || []);
    this.conditionsMap = null;
    this.executionMap = null;
  }

  Gax = (t, e) => {
    for (var n = -1, r = null == t ? 0 : t.length; ++n < r; )
      if (e(t[n], n, t)) return !0;
    return !1;
  };
  getMergedRules = (e) => {
    var t = new Set(),
      n = new Set();
    BsyUtils.forEach(e, function (key, e) {
      BsyUtils.forEach(e.fields, function (key, e) {
        t.has(e) && n.add(e);
        t.add(e);
      });
    });
    var r = Array.from(n),
      a = [];

    BsyUtils.forEach(r, function (key, t) {
      var n = e.filter(function (e) {
        return e.fields.includes(t);
      });
      a.push({
        fields: [t],
        filterList: n.map(function (e) {
          return e.filter;
        }),
      });
    });
    BsyUtils.forEach(e, function (key, e) {
      var t = e.fields.filter(function (e) {
        return !r.includes(e);
      });
      if (t.length > 0) {
        a.push({
          fields: t,
          filterList: [e.filter],
        });
      }
    });
    return a;
  };

  hr = (e) => {
    var t = {},
      n = Object.keys(e).length;
    BsyUtils.forEach(e, function (n, e) {
      t[n] = 0;
    });
    BsyUtils.forEach(e, function (key, e) {
      BsyUtils.forEach(e, function (key, e) {
        t[e]++;
      });
    });
    var r = [];
    for (var o in t) 0 === t[o] && r.push(o);
    for (var i = []; r.length > 0; ) {
      var c = r.shift();
      if ((i.push(c), i.length > n)) break;
      BsyUtils.forEach(e[c], function (key, e) {
        t[e]--;
        0 === t[e] && r.push(e);
      });
    }
    return i;
  };
  getOrder = (e) => {
    var t = this.ee(e),
      n = this.hr(t);
    return n.length !== Object.keys(t).length ? [] : n;
  };

  ee = (e) => {
    e = cloneDeep(e);
    var that = this;
    var t = new Set(),
      n = new Map();
    BsyUtils.forEach(e, function (key, e) {
      var r = get(e, "fields", []),
        // a = BsyUtils.arrayUnique(
        //   get(e, "filter.cond", []).map(function (e) {
        //     return e.field;
        //   })
        // );
        a = BsyUtils.arrayUnique(
          get(e, "filter.cond", []).map(function (e) {
            return e.field;
          })
        );
      BsyUtils.forEach(a, function (key, e) {
        if ((t.add(e), n.has(e))) {
          var a = n.get(e);
          n.set(e, BsyUtils.arrayUnique(that.concatArrays(a, r)));
        } else n.set(e, r);
      });
      BsyUtils.forEach(r, function (key, e) {
        t.add(e);
      });
    });
    var r = Array.from(t),
      a = {};

    BsyUtils.forEach(r, function (key, e) {
      a[e] = n.get(e) || [];
    });
    return a;
  };

  initFields = (e) => {
    var t = [];
    BsyUtils.forEach(e, function (key, e) {
      if (e)
        if (e.widget) {
          var n = e.widget; // e(0, d.Ev)(e);
          n && t.push(n);
        } else t.push(e);
    });
    return t;
  };

  _getSortedRules = () => {
    var e = {};
    BsyUtils.forEach(this.mergedShowRules, function (n, t) {
      var r = Object.assign(
        {
          id: n,
        },
        t
      );
      BsyUtils.forEach(t.fields, function (key, t) {
        e[t] = r;
      });
    });
    var t = new Set();
    BsyUtils.forEach(this.fields, function (key, e) {
      t.add(e.widgetName);
    });
    var n = [],
      r = {};
    BsyUtils.forEach(this.order, function (key, a) {
      var i = e[a];
      if (i && t.has(a)) {
        if (!r[i.id]) {
          n.push(i);
          r[i.id] = true;
        }
      }
    });
    return n;
  };

  getConditionsFromRule = (e) => {
    let a = this;
    var t = [];
    return (
      BsyUtils.forEach(e.filterList, function (key, e) {
        return a.concatArrays(t, get(e, "cond", []));
      }),
      t
    );
  };

  _initWidgetFilterMap = () => {
    return {
      text: TextWidgetFilter,
      number: NumberWidgetFilter,
      datetime: DatetimeWidgetFilter,
      combocheck: ComboCheckWidgetFilter,
      textarea: TextareaWidgetFilter,
      address: AddressWidgetFilter,
      user: UserWidgetFilter,
      usergroup: UserGroupWidgetFilter,
      dept: DeptWidgetFilter,
      deptgroup: DeptGroupWidgetFilter,
      signature: SignatureWidgetFilter,
      file_list: FileListWidgetFilter,
    };
  };
  getConditionsMap = () => {
    var e = this,
      t = {},
      n = {};
    BsyUtils.forEach(this.sortedShowRules, function (key, a) {
      BsyUtils.forEach(e.getConditionsFromRule(a), function (key, e) {
        var i = get(e, "field");

        if (t[i]) {
          if (!get(n[i], a.id)) {
            t[i].push(a);
            n[i][a.id] = true;
          }
        } else {
          t[i] = [a];
          n[i] = { [a.id]: true };
        }

        // t[i]
        //   ? get(n[i], a.id) || (t[i].push(a), (n[i][a.id] = !0))
        //   : ((t[i] = [a]), (n[i] = (0, r.Z)({}, a.id, !0)));
      });
    });
    return t;
  };
  getExecutionMap = () => {
    var e = this;
    this.conditionsMap || (this.conditionsMap = this.getConditionsMap());
    var t = {};
    BsyUtils.forEach(this.conditionsMap, function (n, r) {
      var a = e.pickExecuteRules(r, {}),
        i = {};
      BsyUtils.forEach(a, function (key, e) {
        i[e.id] = !0;
      });
      var o = [];
      BsyUtils.forEach(e.sortedShowRules, function (key, e) {
        i[e.id] && o.push(e);
      })((t[r] = o));
    });
    return t;
  };
  pickExecuteRules = (e, t, n) => {
    var r = this,
      a = get(this.conditionsMap, e);
    if (BsyUtils.isObjectEmpty(a)) return [];
    var i = n || [];
    BsyUtils.forEach(a, function (e) {
      if (!t[e.id]) {
        i.push(e);
        t[e.id] = true;
        // (0, u.t8m)(t, e.id, true);
        BsyUtils.forEach(e.fields, function (key, field) {
          r.pickExecuteRules(field, t, i);
        });
      }
    });
    return i;
  };
  getWidgetRules = (e) => {
    return e ? get(this.executionMap, e, []) : this.sortedShowRules;
  };
  getVisibleMap = (e, t, n, r, a) => {
    var i = this;
    this.executionMap || (this.executionMap = this.getExecutionMap());
    var o = {},
      l = this.getWidgetRules(n);
    return (
      BsyUtils.isObjectEmpty(l) ||
        BsyUtils.forEach(l, function (key, l) {
          if (
            (BsyUtils.forEach(i.getConditionsFromRule(l), function (key, t) {
              var n = get(t, "field");
              o[n] || (e.isHideByShowRules(n, r, a) && (o[n] = !1));
            }),
            BsyUtils.forEach(l.fields, function (key, e) {
              o[e] = o[e] || !1;
            }),
            !n || i.checkConditionsRelyFinished(l, t, r, a))
          ) {
            var c = i.getValueMap(e, i.getConditionsFromRule(l), r, a);
            i.isConditionsMatch(
              l,
              c,
              o,
              function (t, n, r) {
                var a = n ? [n, t].join(".") : t;
                return get(e.getField(a, r), "visible", !1);
              },
              r,
              a
            ) &&
              BsyUtils.forEach(l.fields, function (key, e) {
                o[e] = !0;
              });
          }
        }),
      o
    );
  };
  getViewVisibleMap = (e, t) => {
    var n = this,
      r = {};
    this.sortedShowRules.map((a) => {
      a.fields.map((e) => {
        r[e] = r[e] || !1;
      });
      const ret = n.isConditionsMatch(a, e, r, t);
      if (ret) {
        a.fields.map((e) => {
          r[e] = !0;
        });
      }
    });
    return r;
  };
  getValueMap = (e, t, n, r) => {
    var a = this,
      i = {};
    return (
      BsyUtils.forEach(t, function (key, t) {
        var o = n ? [n, t.field].join(".") : t.field,
          l = e.getField(o, r);
        l && (i[t.field] = a.getShowRuleValue(l, t));
      }),
      i
    );
  };

  getShowRuleValue = (e, t) => {
    if ("linkobject" === e.type) {
      if (t.method === "link_to") {
        var n = get(e, "value.link_form"),
          r = get(e, "widget.links[0].form");
        return n || r;
      }
      return e.linkValue;
    }
    return e.linkValue;
  };

  isConditionsMatch = (e, t, n, r, a, i) => {
    var o = this;
    var fret = this.Gax(e.filterList, function (e) {
      var l = get(e, "cond", []);
      var mret = o.getMatchMethod(e.rel)(l, function (e) {
        if (r(e.field, a, i) && !1 === n[e.field]) return !1;
        var l = t[e.field];
        if (e.type === "number") {
          l = BsyUtils.fixDecimalPrecision(l);
        }
        var ret = o.isCondItemMatch(e, l);
        return ret;
      });
      return mret;
    });
    return fret;
  };

  isCondItemMatch = (t, e) => {
    var i = this.widgetFilterMap[t.type];
    return !!i && new i(t).invoke()(e);
  };
  getMatchMethod = (t) => {
    return t === "or"
      ? function (t, e) {
          return !!isEmpty(t) || some(t, e);
        }
      : every;
  };
  checkConditionsRelyFinished = (e, t, n, r) => {
    var a = this.getConditionsFromRule(e);
    if (BsyUtils.isObjectEmpty(a)) return !1;
    var i = !0;

    return i;
  };
  concatArrays = (t, e) => {
    return t.concat(Array.isArray(e) ? e : [e]);
  };
}
